import type { UspRowResolved } from './types';
import { Text } from '@/lib/render/Text';

export function UspRowComponent({ resolved }: { resolved: UspRowResolved }) {
  const items = resolved.items ?? [];

  if (items.length === 0) {
    return null;
  }

  const midpoint = Math.ceil(items.length / 2);
  const leftItems = items.slice(0, midpoint);
  const rightItems = items.slice(midpoint);

  return (
    // Outer box carries the inter-widget rhythm (`pt-4`, top only), inner box
    // keeps the pill's own `px-6 py-3` chrome — see the spacing convention in
    // CLAUDE.md. They cannot share an element without the `pt-*` utility
    // overriding the pill's own top padding.
    <div className="pt-4">
      <div className="flex gap-6 rounded-2xl bg-[var(--color-secondary-lighter)] px-6 py-3">
        <div className="flex flex-col gap-2.5">
          {leftItems.map((item) => (
            <div key={item.text} className="flex items-center gap-1.5">
              <span className="text-primary-dark shrink-0 text-base leading-none font-bold">
                ✓
              </span>
              <Text className="text-primary-dark text-[11px] font-medium">
                {item.text}
              </Text>
            </div>
          ))}
        </div>
        <div className="flex flex-col gap-2.5">
          {rightItems.map((item) => (
            <div key={item.text} className="flex items-center gap-1.5">
              <span className="text-primary-dark shrink-0 text-base leading-none font-bold">
                ✓
              </span>
              <Text className="text-primary-dark text-[11px] font-medium">
                {item.text}
              </Text>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
